import { useTranslation } from "react-i18next";
import Card from "./Card";

export default function List({ data, input }) {
  const { t } = useTranslation();

  const filteredData = data.filter((el) => {
    if (input === "") return true;

    return el.titre
      .toLowerCase()
      .includes(input.toLowerCase());
  });

  // Signature du resultat courant. Posee en key sur le conteneur, elle force
  // React a remonter la grille des que la liste affichee change : c'est ce
  // remontage qui rejoue l'animation CSS d'apparition des cartes.
  // Sans ca l'animation ne se joue qu'une fois, au chargement de la page,
  // alors que l'accordion est encore replie et le conteneur invisible.
  const resultKey = filteredData.map((card) => card.id).join("-");

  return (
    <div key={resultKey} className="flex flex-wrap gap-[15px] w-full">
      {filteredData.map((card, index) => (
        <Card
          key={card.id}
          titre={t(card.titre)}
          texte={t(card.texte)}
          image={card.image}
          animation="css"
          delay={Math.min(index, 8) * 40}
        />
      ))}

    </div>
  );
}